import { render, staticRenderFns } from "./DropdownV2.vue?vue&type=template&id=3d70f910&scoped=true&"
import script from "./DropdownV2.vue?vue&type=script&lang=js&"
export * from "./DropdownV2.vue?vue&type=script&lang=js&"
import style0 from "./DropdownV2.vue?vue&type=style&index=0&id=3d70f910&lang=scss&scoped=true&"
import style1 from "./DropdownV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d70f910",
  null
  
)

export default component.exports